import { render, staticRenderFns } from "./_ui.vue?vue&type=template&id=7096299c&scoped=true&"
import script from "./_ui.vue?vue&type=script&lang=ts&"
export * from "./_ui.vue?vue&type=script&lang=ts&"
import style0 from "./_ui.vue?vue&type=style&index=0&id=7096299c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096299c",
  null
  
)

export default component.exports